export default "__VITE_ASSET__BwdAqL3o__"